import { reactive } from "vue";
import axios from "axios";

export const state = reactive({
  listAnnuaire: [],
  displayedAnnuaire: [],
  listCities: [],
  positions: [],
  query: {
    name: "",
    city: "",
  },
  toast: {
    show: false,
    status: null,
    message: null,
  },
  pagination: {
    totalPages: undefined,
    currentPage: 1,
  },
});

export const wpApiSettings = window.wpApiSettings || {
  root: "http://localhost/wordpress/wp-json/",
  url: "http://localhost/wordpress/",
  dev: true,
};

export const baseUrl = `${wpApiSettings.root}api/v1`;

export const buildUrl = (str) => `${baseUrl}${str}`;

axios.interceptors.request.use((config) => {
  if (wpApiSettings.nonce) {
    config.headers["X-WP-Nonce"] = wpApiSettings.nonce;
  }
  return config;
});

export const getData = async (page) => {
  if (!page) {
    page = 1;
  }

  // let queryUrl = `${URL_API}annuaire/public?page=${page}`;
  let queryUrl = `${wpApiSettings.root}api/v1/annuaire/public?page=${page}&status=accepted`;

  if (state.query.name !== "") {
    queryUrl += `&name=${state.query.name}`;
  }
  if (state.query.city !== "") {
    queryUrl += `&city=${state.query.city}`;
  }

  const req = await axios.get(queryUrl);
  state.listAnnuaire = [];
  state.pagination.totalPages = parseInt(req.data.totalPages);

  Object.keys(req.data.annuaire).forEach((key) => {
    state.listAnnuaire.push(req.data.annuaire[key]);
  });

  state.displayedAnnuaire = state.listAnnuaire;

  state.displayedAnnuaire.forEach((element) => {
    const date = new Date(element.created_at);

    element.formated_date = new Intl.DateTimeFormat("fr-fr").format(date);
  });
};

export const getPositions = async () => {
  state.positions = [];
  let url = `${wpApiSettings.root}api/v1/annuaire/positions`

  if(state.query.name){
    url += `?q=${state.query.name}`;
  }

  const req = await axios.get(url);

  req.data.forEach((position) => {
    position.latitude = parseFloat(position.latitude);
    position.longitude = parseFloat(position.longitude);
    state.positions.push(position);
  });
};

export const getItemAnnuaire = async (id) => {
  const req = await axios.get(
    `${wpApiSettings.root}api/v1/annuaire/user?id=${id}`
  );
  return req.data;
};
